export default class UploadInfo {
  attachmentId: string = "";
  uploadUrl: string = "";

  public constructor(init?: Partial<UploadInfo>) {
    Object.assign(this, init);
  }
}
